import { getIdTokenLocalStorage } from '@sbgsports/vault-sso-auth';

import { vaultApi } from './http';

export async function postVirtualClipFromApi(clips) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.post('/assets/videoClip/', clips);
  return response.data.data;
}

export async function getVirtualClipStatus(id) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  const response = await vaultApi.get(`/assets/videoClipStatus/${id}`);
  return response.data;
}

export async function deleteClipStatus(id, actionStatus, errorMessage) {
  const token = getIdTokenLocalStorage();
  vaultApi.defaults.headers.common.Authorization = `Bearer ${token}`;
  await vaultApi.put(`/assets/videoClipStatus/${id}`, { actionStatus, errorMessage });
}
